import React, { useState, useEffect } from "react"
import MockDataWarning from "./services/helpers/MockDataWarning"
import { facetConfiguration } from "./configuration"
import Search from './Search'
import Kendra from "aws-sdk/clients/kendra"
import S3 from "aws-sdk/clients/s3"
const _loadingErrors = [];

const accessKeyId = process.env.REACT_APP_KENDRA_ACCESS_KEY_ID
const secretAccessKey = process.env.REACT_APP_KENDRA_SECRET_ACCESS_KEY
console.log(accessKeyId)
const KendraSearch = () => {
  
  if (!accessKeyId) {
    _loadingErrors.push(
      `There is no accessKeyId provided`
    )
  }

  if (!secretAccessKey) {
    _loadingErrors.push(
      `There is no secretAccessKey provided`
    )
  }
  
  const hasErrors = _loadingErrors.length > 0;
  if (hasErrors) {
    console.error(JSON.stringify(_loadingErrors));
  }
  
  const errors = _loadingErrors;

  // const indexId = '57810c1e-de07-4b4f-9584-17ddcd19a3d7'
  const indexId = 'c3087b50-4fad-4cd9-9b96-6c6cda835e4a'
  
  // const region = 'us-east-2'
  const region = 'us-east-1'
  
  const kendra = !hasErrors
    ? new Kendra({
        accessKeyId: accessKeyId,
        secretAccessKey: secretAccessKey,
        region: region,
      })
    : undefined;
  
  const s3 = !hasErrors
    ? new S3 ({
        accessKeyId: accessKeyId,
        secretAccessKey: secretAccessKey,
        region: region,
      })
    : undefined;
  
  return (
    <div>
    {errors.length > 0 ? (
      <MockDataWarning errors={errors} />
    ) : (
      <div style={{ textAlign: 'center', paddingTop: 40, fontWeight: 300 }}>
        <h3>Kendra search engine</h3>
        <p>(Test environment)</p>
      </div>
    )}

    <Search
      kendra={kendra}
      s3={s3}
      indexId={indexId}
      facetConfiguration={facetConfiguration}
    />
  </div>
  )
}

export default KendraSearch


// WEBPACK FOOTER //
// ./src/containers/Kendra/Kendra.js